import React, { useEffect, useState } from 'react';
import Overlay from './components/bicester/Overlay';
import GameReward from './pages/GameReward';
import Passport from './pages/Passport';
import InstructionsVillageInfo from './pages/VillageInfo';
import BicesterArtAndCulture from './pages/bicester/ArtAndCulture';
import Instructions from './pages/bicester/Instructions';
import BicesterMember from './pages/bicester/Member';
import BicesterServices from './pages/bicester/Services';
import BicesterSfh from './pages/bicester/ShopFromHome';
import BicesterShoppingExpress from './pages/bicester/ShoppingExpress';
import PersonalShopping from './pages/bicester/apartment/PersonalShopping';
import ApartmentWelcome from './pages/bicester/apartment/Welcome';
import Cecconi from './pages/bicester/restaurants/Cecconi';
import FarmShop from './pages/bicester/restaurants/FarmShop';
import LatuaPasta from './pages/bicester/restaurants/LatuaPasta';
import ShanShui from './pages/bicester/restaurants/ShanShui';
import AppartmentServices from './pages/bicester/apartment/Services';
import { disptchCTAClickObject } from './Analytics';

const villageName = 'bicester';

function BicesterApp() {
  const [activeScene, setActiveScene] = useState('room-1');
  const [instructionsActive, setInstructionsActive] = useState(false);
  const [villageInfoActive, setVillageInfoActive] = useState(false);
  const [passportActive, setPassportActive] = useState(false);
  const [gameRewardActive, setGameRewardActive] = useState(false);
  const [farmshopActive, setFarmshopActive] = useState(false);
  const [cecconiActive, setCecconiActive] = useState(false);
  const [latuaPastaActive, setLatuaPastaActive] = useState(false);
  const [shanShuiActive, setShanShuiActive] = useState(false);
  const [shoppingExpressActive, setShoppingExpressActive] = useState(false);
  const [artCultureActive, setArtCultureActive] = useState(false);
  const [memberActive, setMemberActive] = useState(false);
  const [personalShoppingActive, setPersonalShoppingActive] = useState(false);
  const [sfhActive, setSfhActive] = useState(false);
  const [apartmentWelcomeActive, setApartmentWelcomeActive] = useState(false);
  const [apartmentServicesActive, setApartmentServicesActive] = useState(false);
  const [servicesActive, setServicesActive] = useState(false);

  const openVillageInfo = () => {
    setVillageInfoActive(true);
  };

  const closeInstructions = () => {
    disptchCTAClickObject('bicester', 'Button', 'Instructions', 'Close', '');
    setInstructionsActive(false);
    setVillageInfoActive(true);
  };

  const openPassport = () => {
    disptchCTAClickObject('bicester', 'Button', 'Passport', 'Open', '');
    setPassportActive(true);
  };

  const closePassport = () => {
    disptchCTAClickObject('bicester', 'Button', 'Passport', 'Close', '');
    setPassportActive(false);
  };

  const updateActiveScene = (sceneName: string) => {
    if (activeScene !== sceneName) {
      setActiveScene(sceneName);
      window.changeUrls();
    }
  };

  const openGameReward = () => {
    disptchCTAClickObject('bicester', 'Button', 'GameReward', 'Open', '');
    setGameRewardActive(true);
  };

  const closeGameReward = () => {
    disptchCTAClickObject('bicester', 'Button', 'GameReward', 'Close', '');
    setGameRewardActive(false);
  };

  const openFarmshop = () => {
    disptchCTAClickObject('bicester', 'Button', 'Farmshop', 'Open', '');
    setFarmshopActive(true);
  };

  const closeFarmshop = () => {
    disptchCTAClickObject('bicester', 'Button', 'Farmshop', 'Close', '');
    setFarmshopActive(false);
  };

  const openCecconi = () => {
    disptchCTAClickObject('bicester', 'Button', 'Cecconi', 'Open', '');
    setCecconiActive(true);
  };

  const closeCecconi = () => {
    disptchCTAClickObject('bicester', 'Button', 'Cecconi', 'Close', '');
    setCecconiActive(false);
  };

  const openLatuaPasta = () => {
    disptchCTAClickObject('bicester', 'Button', 'Latua', 'Open', '');
    setLatuaPastaActive(true);
  };

  const closeLatuaPasta = () => {
    disptchCTAClickObject('bicester', 'Button', 'Latua', 'Close', '');
    setLatuaPastaActive(false);
  };

  const openShanShui = () => {
    disptchCTAClickObject('bicester', 'Button', 'ShanShui', 'Open', '');
    setShanShuiActive(true);
  };

  const closeShanShui = () => {
    disptchCTAClickObject('bicester', 'Button', 'ShanShui', 'Close', '');
    setShanShuiActive(false);
  };

  const openBicesterShoppingExpress = () => {
    disptchCTAClickObject('bicester', 'Button', 'ShoppingExpress', 'Open', '');
    setShoppingExpressActive(true);
  };

  const closeBicesterShoppingExpress = () => {
    disptchCTAClickObject('bicester', 'Button', 'ShoppingExpress', 'Close', '');
    setShoppingExpressActive(false);
  };

  const openBicesterAc = () => {
    disptchCTAClickObject('bicester', 'Button', 'ArtCulture', 'Open', '');
    setArtCultureActive(true);
  };

  const closeBicesterAc = () => {
    disptchCTAClickObject('bicester', 'Button', 'ArtCulture', 'Close', '');
    setArtCultureActive(false);
  };

  const openBicesterMember = () => {
    disptchCTAClickObject('bicester', 'Button', 'Member', 'Open', '');
    setMemberActive(true);
  };

  const closeBicesterMember = () => {
    disptchCTAClickObject('bicester', 'Button', 'Member', 'Close', '');
    setMemberActive(false);
  };

  const openBicesterPersonalShopping = () => {
    disptchCTAClickObject('bicester', 'Button', 'PersonalShopping', 'Open', '');
    setPersonalShoppingActive(true);
  };

  const closeBicesterPersonalShopping = () => {
    disptchCTAClickObject('bicester', 'Button', 'PersonalShopping', 'Close', '');
    setPersonalShoppingActive(false);
  };

  const openBicesterSfh = () => {
    disptchCTAClickObject('bicester', 'Button', 'ShopFromHome', 'Open', '');
    setSfhActive(true);
  };

  const closeBicesterSfh = () => {
    disptchCTAClickObject('bicester', 'Button', 'ShopFromHome', 'Close', '');
    setSfhActive(false);
  };

  const openBicesterApartmentWelcome = () => {
    disptchCTAClickObject('bicester', 'Button', 'ApartmentWelcome', 'Open', '');
    setApartmentWelcomeActive(true);
  };

  const closeBicesterApartmentWelcome = () => {
    disptchCTAClickObject('bicester', 'Button', 'ApartmentWelcome', 'Close', '');
    setApartmentWelcomeActive(false);
  };

  const openBicesterApartmentServices = () => {
    disptchCTAClickObject('bicester', 'Button', 'ApartmentServices', 'Open', '');
    setApartmentServicesActive(true);
  };

  const closeBicesterApartmentServices = () => {
    disptchCTAClickObject('bicester', 'Button', 'ApartmentServices', 'Close', '');
    setApartmentServicesActive(false);
  };

  const openBicesterServices = () => {
    disptchCTAClickObject('bicester', 'Button', 'BicesterServices', 'Open', '');
    setServicesActive(true);
  };

  const closeBicesterServices = () => {
    disptchCTAClickObject('bicester', 'Button', 'BicesterServices', 'Close', '');
    setServicesActive(false);
  };

  const closeVillageInfo = () => {
    setVillageInfoActive(false);
    disptchCTAClickObject('bicester', 'Button', 'VillageInfo', 'close', '');
  };

  useEffect(() => {
    window.openVillageInfo = openVillageInfo;
    window.openPassport = openPassport;
    window.updateActiveScene = updateActiveScene;
    window.openGameReward = openGameReward;
    window.openBicesterServices = openBicesterServices;
    window.openFarmshop = openFarmshop;
    window.openCecconi = openCecconi;
    window.openLatuaPasta = openLatuaPasta;
    window.openShanShui = openShanShui;
    window.openBicesterAc = openBicesterAc;
    window.openBicesterShoppingExpress = openBicesterShoppingExpress;
    window.openBicesterSfh = openBicesterSfh;
    window.openBicesterMember = openBicesterMember;
    window.openBicesterPersonalShopping = openBicesterPersonalShopping;
    window.openBicesterApartmentWelcome = openBicesterApartmentWelcome;
    window.openBicesterApartmentServices = openBicesterApartmentServices;
  }, []);

  return (
    <>
      {/* <LoadingScreen setLoadUI={() => setLoadUI(true)} /> */}
      {/* {loadUI && ( */}
      <>
        <Overlay
          closeAllUI={() => {
            setInstructionsActive(false);
          }}
          openFirstModal={() => setInstructionsActive(true)}
          activeScene={activeScene}
          setActiveScene={setActiveScene}
          togglePassport={() => {
            const cta_action: string = passportActive ? 'Open' : 'Close';
            disptchCTAClickObject('bicester', 'Button', 'Passport', cta_action, '');
            setPassportActive(!passportActive);
          }}
          toggleInstructions={() => {
            const cta_action: string = instructionsActive ? 'Open' : 'Close';
            disptchCTAClickObject('bicester', 'Button', 'Instructions', cta_action, '');
            setInstructionsActive(!instructionsActive);
          }}
          // toggleMap={() => {
          //   setMapActive(!mapActive);
          // }}
        />
        <Instructions active={instructionsActive} setActive={closeInstructions} />
        <InstructionsVillageInfo
          active={villageInfoActive}
          setActive={() => closeVillageInfo()}
          villageName={villageName}
        />
        <Passport active={passportActive} setActive={() => closePassport()} villageName={villageName} />
        <GameReward villageName="bicester" active={gameRewardActive} setActive={() => closeGameReward()} />
        <FarmShop active={farmshopActive} setActive={() => closeFarmshop()} />
        <Cecconi active={cecconiActive} setActive={() => closeCecconi()} />
        <LatuaPasta active={latuaPastaActive} setActive={() => closeLatuaPasta()} />
        <ShanShui active={shanShuiActive} setActive={() => closeShanShui()} />
        <BicesterServices active={servicesActive} setActive={() => closeBicesterServices()} />
        <BicesterArtAndCulture active={artCultureActive} setActive={() => closeBicesterAc()} />
        <BicesterShoppingExpress active={shoppingExpressActive} setActive={() => closeBicesterShoppingExpress()} />
        <BicesterSfh active={sfhActive} setActive={() => closeBicesterSfh()} />
        <BicesterMember active={memberActive} setActive={() => closeBicesterMember()} />
        <PersonalShopping active={personalShoppingActive} setActive={() => closeBicesterPersonalShopping()} />
        <ApartmentWelcome active={apartmentWelcomeActive} setActive={() => closeBicesterApartmentWelcome()} />
        <AppartmentServices active={apartmentServicesActive} setActive={() => closeBicesterApartmentServices()} />
      </>
      {/* )} */}
    </>
  );
}

export default BicesterApp;
